import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import type { RepoBulkAnswer } from '../lib/repo-enablement';
import { count } from '../lib/time';

/** How long setup takes, or nothing on a disable, whose work is cancelled rather than queued. */
export function RepoEnablementPace(props: { readonly answer: RepoBulkAnswer }): JSX.Element {
  return (
    <Show when={props.answer.setup}>
      {(setup) => (
        <p class="repo-enablement__line">
          {t('repo_enablement.pace', {
            rate: count(setup().rate_per_minute),
            minutes: count(setup().eta_minutes),
          })}
        </p>
      )}
    </Show>
  );
}
